export default __webpack_public_path__ + "media/images/favicon-843144edd0ef75143a9c83ebc4df7cb9.png";